/* Scoped to grid_bota_us. Native checkout, tracking and purchase widget are untouched. */
(function () {
  'use strict';
  var script = document.currentScript;
  var contentUrl = script && script.dataset.contentUrl;
  var contentLoaded = false;
  function loadContent() {
    if (contentLoaded || !contentUrl) return;
    contentLoaded = true;
    var asset = document.createElement('script');
    asset.src = contentUrl;
    asset.defer = true;
    asset.onerror = function () { contentLoaded = false; };
    document.head.appendChild(asset);
  }
  function initGallery(gallery) {
    if (gallery.dataset.gridBound) return;
    gallery.dataset.gridBound = '1';
    var slider = gallery.querySelector('slider-element');
    if (!slider) return;
    function hydrate(cell, eager) {
      if (!cell) return;
      var template = cell.querySelector('template[data-grid-image]');
      if (!template) return;
      var image = template.content.querySelector('img').cloneNode(true);
      image.loading = eager ? 'eager' : 'lazy';
      image.fetchPriority = eager ? 'auto' : 'low';
      var placeholder = cell.querySelector('[data-grid-placeholder]');
      if (placeholder) placeholder.replaceWith(image);
      template.remove();
    }
    var cells = Array.prototype.slice.call(slider.querySelectorAll('.product__media'));
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { hydrate(entry.target, true); observer.unobserve(entry.target); }
        });
      }, { root: slider, threshold: 0.05 });
      cells.forEach(function (cell) { if (cell.querySelector('[data-grid-image]')) observer.observe(cell); });
    } else {
      cells.forEach(function (cell) { hydrate(cell, false); });
    }
    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('.product__thumbnail[data-media-id]');
      if (thumb) {
        var id = thumb.getAttribute('data-media-id');
        cells.forEach(function (cell) { if (cell.getAttribute('data-media-id') === id) hydrate(cell, true); });
      }
      if (event.target.closest('[is="media-lightbox-button"], [is="media-hover-button"]')) {
        // PhotoSwipe reads every image URL when it opens; keep its complete data source.
        cells.forEach(function (cell) { hydrate(cell, false); });
      }
    }, true);
    slider.addEventListener('slider:change', function (event) {
      hydrate(event.detail && event.detail.currentElement, true);
    }, true);
    slider.addEventListener('pointerdown', function () {
      var activeIndex = Math.max(0, (slider.currentPage || 1) - 1);
      hydrate(cells[activeIndex + 1], true);
      hydrate(cells[activeIndex - 1], true);
    }, { passive: true });
  }
  function boot() {
    document.querySelectorAll('[data-grid-gallery]').forEach(initGallery);
    var contentRoots = document.querySelectorAll('[data-vrx-root], [data-bac-root], [data-n8ss], [data-rvx-root]');
    if (!contentRoots.length || contentLoaded) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); loadContent(); }
      }, { rootMargin: '1000px 0px' });
      contentRoots.forEach(function (root) { observer.observe(root); });
    } else { loadContent(); }
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
